import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import {
  ADMIN,
  AGENT_AUTOMATION,
  AGENT_AUTOMATION_MODIFY,
  AGENT_AUTOMATION_SAVE,
  BANK_COMPLIANCE,
  CHATBOT_CUSTOMESERVICE,
  CHATBOT_DOCUMENT,
  CHATBOT_LND_AGENT,
  CHATS,
  CLAIM_AUDIT_LOGS,
  CUSTOMER_CARE,
  EXTRACTS,
  INVESTMENT,
  LEGAL_COMPLAINTS,
  LEGAL_COMPLAINTS_ADMIN,
  LEGAL_EXPENSE,
  LEGAL_EXPENSE_CREATE_CASE,
  LEGAL_EXPENSE_MODIFY_CASE,
  LEGAL_EXPENSE_CREATE_EXPENSE,
  LEGAL_EXPENSE_MODIFY_EXPENSE,
  PRODUCTION_TASK,
  PRODUCTION_TASK_CREATE,
  PRODUCTION_TASK_MODIFY,
  PRODUCTION_TASK_SUPERVISOR,
  RECORD_CATALOG,
  SALESBOARD,
  UNDERWRITING,
  WORKSITE_TRACKER,
  WORKSITE_TRACKER_VOID,
  FHDHIERARCHY,
  OUTAGE_TRACKER,
  FHDINPUTFORM,
  CLAIM_AUDIT_LOGS_MANAGER,
  CUSTOMER_CARE_USER,
  CUSTOMER_CARE_SUPERVISOR,
  CUSTOMER_CARE_ADMIN,
  FHDHIERARCHY_ADMIN,
  INVESTMENT_CREDIT_ADMIN,
  PS_ENTRY_FORM_MANUAL,
  PS_ENTRY_FORM_AUTO,
  GROWTH_ADJUSTMENTS,
  QnA,
  DATA_CATALOGUE,
  CHATBOT_ENTERPRISE_ASSISTANT,
  PROJECTIONS_PROMOTIONS,
  PREMIUM_ACCOUNTING_USER,
  PREMIUM_ACCOUNTING_SUPERVISOR,
  PREMIUM_ACCOUNTING_ADMIN,
  PREMIUM_ACCOUNTING,
} from 'src/app/constants/permissions';
import { environment } from 'src/environments/environment';
import { UserInfo } from '../state/user/user-info';
import {
  loggingOut,
  setUserAuthenticated,
  setUserInfo,
} from '../state/user/user.store';
import { IAuthService } from './iauth.service';

@Injectable()
export class LocalAuthService implements IAuthService {
  private sesExpired = false;
  constructor(private router: Router) {}
  isTokenExpired(): boolean {
    return true;
  }

  setOAuthConfiguration(company: string): void {}

  login(state: string): void {
    this.sesExpired = false;
    alert('loging in');
    this.router.navigateByUrl('/login/callback');
  }

  checkSession(): boolean {
    setUserAuthenticated(true);
    return true;
  }

  forceLogout(): void {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['logout']);
    location.reload();
  }

  getToken(): Observable<{ state: string | undefined; validToken: boolean }> {
    return of({
      state: environment.defaultRoute,
      validToken: true,
    });
  }

  public refresh(): void {
    console.log('refreshing' + new Date());
  }

  getUserInfo(): Observable<UserInfo> {
    const info: UserInfo = {
      name: 'Benjamin',
      lastName: 'Sandoval',
      email: 'devtest@test.com',
      userName: 'devtest',
      frontActions: [
        CUSTOMER_CARE,
        AGENT_AUTOMATION,
        AGENT_AUTOMATION_SAVE,
        AGENT_AUTOMATION_MODIFY,
        WORKSITE_TRACKER,
        EXTRACTS,
        RECORD_CATALOG,
        WORKSITE_TRACKER_VOID,
        BANK_COMPLIANCE,
        CLAIM_AUDIT_LOGS,
        CLAIM_AUDIT_LOGS_MANAGER,
        PRODUCTION_TASK_MODIFY,
        PRODUCTION_TASK,
        PRODUCTION_TASK_CREATE,
        PRODUCTION_TASK_SUPERVISOR,
        SALESBOARD,
        UNDERWRITING,
        CHATS,
        CHATBOT_CUSTOMESERVICE,
        ADMIN,
        INVESTMENT,
        INVESTMENT_CREDIT_ADMIN,
        LEGAL_EXPENSE,
        LEGAL_EXPENSE_CREATE_CASE,
        LEGAL_EXPENSE_MODIFY_CASE,
        LEGAL_EXPENSE_CREATE_EXPENSE,
        LEGAL_EXPENSE_MODIFY_EXPENSE,
        CHATBOT_DOCUMENT,
        LEGAL_COMPLAINTS,
        LEGAL_COMPLAINTS_ADMIN,
        OUTAGE_TRACKER,
        FHDINPUTFORM,
        'chatbot_customerservice_GLOBE',
        'chatbot_customerservice_AIL',
        'chatbot_customerservice_LND',
        'chatbot_customerservice_UA',
        'chatbot_customerservice_MILITARY',
        CHATBOT_LND_AGENT,
        'chatbot_lndagent_WS',
        'chatbot_lndagent_IND',
        FHDHIERARCHY,
        CHATBOT_ENTERPRISE_ASSISTANT,
        CUSTOMER_CARE_USER,
        CUSTOMER_CARE_SUPERVISOR,
        CUSTOMER_CARE_ADMIN,
        FHDHIERARCHY_ADMIN,
        GROWTH_ADJUSTMENTS,
        PS_ENTRY_FORM_MANUAL,
        PS_ENTRY_FORM_AUTO,
        QnA,
        DATA_CATALOGUE,
        PROJECTIONS_PROMOTIONS,
        PREMIUM_ACCOUNTING,
        PREMIUM_ACCOUNTING_USER,
        PREMIUM_ACCOUNTING_SUPERVISOR,
        PREMIUM_ACCOUNTING_ADMIN,
      ],
    };
    setUserInfo(info);
    return of<UserInfo>(info);
  }

  public sessionExpired(): void {
    if (!this.sesExpired) {
      this.sesExpired = true;
      setUserAuthenticated(false);
      this.router.navigate(['logout'], {
        queryParams: { urlState: this.router.url },
      });
    }
  }

  public getSchema(): string {
    return 'Bearer';
  }

  getAccessToken(): string {
    return 'eyJhbGciOiJSUzI1NiIsIng1dCI6IkdCekJFWXJXMXNwOXJ5eDhacTBBVEZQYXZOQSIsImtpZCI6IkdCekJFWXJXMXNwOXJ5eDhacTBBVEZQYXZOQSIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIxMWE2NTc5YTJmYTQ0NmExYTkxYmJhZDNiOWFhODc3NiIsImNsaWVudF9pZCI6Ijk0NTM2NmMyMDJkMTQ5MmJiMTM4ODY1OGFlMjk0ZTZiIiwic2NvcGUiOlsiYWRkcmVzcyIsImVtYWlsIiwib2F1dGgiLCJvZmZsaW5lX2FjY2VzcyIsIm9wZW5pZCIsInBob25lIiwicHJvZmlsZSJdLCJzdWIiOiJieHNhbmRvdmFsIiwiYXV0aF90aW1lIjoxNzUwNzg3ODYwLCJpZHAiOiJTZWN1cmVBdXRoNzUiLCJpYXQiOjE3NTA3OTEwMzEsImFtciI6WyJwYXNzd29yZCJdLCJuYmYiOjE3NTA3OTEwMzAsImV4cCI6MTc1MDc5NDYzMCwiaXNzIjoiaHR0cHM6Ly9kZXZzc28uZ2xvYmVsaWZlaW5jLmNvbS9TZWN1cmVBdXRoNzUiLCJhdWQiOiJodHRwczovL2RldnNzby5nbG9iZWxpZmVpbmMuY29tL1NlY3VyZUF1dGg3NSJ9.gFsemp0XIMjHwBnH2t6z0PN5LP55sPwOTj-KrISGKfDhmJAqYVfB6c6pyKtuyTvUErVfn535MNLJiTDicfBZ3fLhfjlGNhqsYuzbJwV-VkUjz9ISAodbb9glyf7ebluxXnLgd-N4VrYOtAfksMoMP2fLwoo3QcAi-8gDQ4Ux8s7gf97w3UcK153dbeWj9VWLE4sceRiOmmwidSNqGoV5D6VEHDSzbNkuvGWC5-Qz4Sypw86uu6DE0leQny4-12Up9l64qhHwcVu8dTBAB-unMTkQxOUwfvgyxRM0xTj3Y0ybtJXJO7s6NFxxUuB8m4sNicC29iATPIOf6XdtIjcFZA';
  }

  logout(): void {
    loggingOut();
    setUserAuthenticated(false);
    this.router.navigateByUrl('/logout');
  }
}
